import React from 'react';
import ReactDOM from 'react-dom/client';
import config from '@medflex/utils/config';
import initApm from '../utils/initApm';
import PhysicianEntry from './Physician/Entry';
import '../components/theme/index.css';

// @ts-ignore
global.MEDFLEX_CLIENT_VERSION = config.VERSION;

initApm(config);

const rootNode = document.getElementById('app-main');
if (!rootNode) throw new Error('RootNode is missing!');

const root = ReactDOM.createRoot(rootNode);

root.render(React.createElement(PhysicianEntry));
